import { createContext } from 'react';
var TableContext = createContext(undefined);
export default TableContext;
//# sourceMappingURL=TableContext.js.map